export default function Footer() {
  return (
    <footer className="bg-stone-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/20f82aeec2f5e698a996684cc4a84b3a.jpeg"
                alt="CrownBoostAdsJob"
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <div className="font-bold text-lg">CrownBoost</div>
                <div className="text-amber-400 text-xs">AdsJob Portal</div>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-5">
              Your premier destination for jobs, advertisements, business opportunities, and career growth. Powered by Crown Ad &amp; ZhaoPin.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-circle-fill", label: "Facebook" },
                { icon: "ri-twitter-x-fill", label: "Twitter" },
                { icon: "ri-youtube-fill", label: "YouTube" },
                { icon: "ri-tiktok-fill", label: "TikTok" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-700 hover:bg-amber-500 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* For Job Seekers */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-amber-400 uppercase tracking-wider">For Job Seekers</h4>
            <ul className="space-y-2">
              {["Browse Jobs", "Upload Resume", "Career Resources", "Salary Guide", "Job Alerts", "Success Stories"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* For Employers */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-amber-400 uppercase tracking-wider">For Employers</h4>
            <ul className="space-y-2">
              {["Post a Job", "Pricing Plans", "Employer Dashboard", "Recruitment Tools", "Featured Listings", "Advertise With Us"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-amber-400 uppercase tracking-wider">Company</h4>
            <ul className="space-y-2 mb-5">
              {["About Us", "Contact", "Press", "Careers", "Blog", "Help Center"].map((item) => (
                <li key={item}>
                  <a href="#" className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer">{item}</a>
                </li>
              ))}
            </ul>
            <div className="space-y-2 text-stone-400 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-amber-400"></i>
                <span>info@crownboostadsjob.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-amber-400"></i>
                <span>+1 (888) 276-9600</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            &copy; 2026 CrownBoostAdsJob.com — Crown Ad &amp; ZhaoPin. All rights reserved.
          </p>
          <div className="flex gap-4">
            {["Privacy Policy", "Terms of Service", "Cookie Policy"].map((item) => (
              <a key={item} href="#" className="text-stone-500 hover:text-stone-300 text-xs transition-colors cursor-pointer whitespace-nowrap">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
